import { useState, useEffect } from 'react';
import { fetchWrapper } from '@/lib/fetch-wrapper';
import { BudgetV2Dto } from '@cloudcost/shared-types/budgets';
import { urls } from '@/urls';

export interface GlobalBudgetData {
  original_currency_value: number;
  original_currency: string;
}

export function useGlobalBudget() {
  const [globalBudget, setGlobalBudget] = useState<GlobalBudgetData | null>(
    null,
  );
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchGlobalBudget = async () => {
    try {
      setLoading(true);
      setError(null);
      // Budgets v2 is the source of truth for yearly limits/currency.
      // Scope: global => no departmentId, no systemId.
      const data = (await fetchWrapper.get(
        urls.DevOps.getLatestBudgetV2ForScope(),
      )) as BudgetV2Dto;
      setGlobalBudget({
        original_currency_value: Number(data.yearly_limit),
        original_currency: data.currency,
      });
    } catch (err) {
      const status = (err as any)?.response?.status;
      // When no global budget exists yet, backend returns 404.
      // Treat that as "not set" rather than an error state.
      if (status === 404) {
        setGlobalBudget(null);
        setError(null);
      } else {
        setError('Failed to fetch global budget');
        console.error('Error fetching global budget:', err);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGlobalBudget();
  }, []);

  return {
    globalBudget,
    loading,
    error,
    refetch: fetchGlobalBudget,
  };
}
